<template>
  <div>
    <div v-if="loading">
      <div class="text-center pt-10">
        <v-progress-circular
          color="primary"
          indeterminate
          size="60"
        ></v-progress-circular>
      </div>
    </div>
    <template v-else>
      <div class="text-center mt-2">
        <img width="62px" src="@/assets/logo.png" />
      </div>

      <div
        class="Kanit primary pa-4 text-center white--text"
        style="font-size: 22px"
      >
        ประวัติการสะสมคะแนน
      </div>
      <Collect
        class="Kanit"
        :edittype="edittype"
        :editdata="editdata"
        @success="handleEditSuccess"
      ></Collect>
    </template>
  </div>
</template>

<script>
import Collect from "./Collect.vue";
import axios from "axios";

export default {
  components: { Collect },
  data() {
    return {
      edittype: "edit",
      editdata: null,
      loading: false,
    };
  },
  mounted() {
    this.handleGetRewardById();
  },
  methods: {
    async handleGetRewardById() {
      const vm = this;
      try {
        const rewardId = vm.query.id;
        const url = `${vm.serverUrl}toacrm/history-reward-points/${rewardId}`;

        vm.loading = true;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
        });
        vm.loading = false;

        if (response && response.status === 200) {
          const tempData = response.data.data;

          if (
            tempData.admin_status_option ===
            "ยกเลิกรายการ เนื่องจากไม่ทำรายการภายในเวลาที่กำหนด"
          ) {
            vm.handleExpiredOrder();
          } else {
            vm.editdata = tempData;
          }
        }
      } catch (error) {
        vm.loading = false;
        console.error(error);
      }
    },
    async handleEditSuccess() {
      await this.$store.dispatch("sendMessage", "แก้ไขข้อมูลสำเร็จ");
      this.$liff.closeWindow();
    },
    async handleExpiredOrder() {
      const vm = this;
      const result = await vm.$swal.fire({
        icon: "error",
        html: "ยกเลิกรายการ เนื่องจากไม่ทำรายการภายในเวลาที่กำหนด",
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: "custom-swal",
        confirmButtonText: "ตกลง",
      });

      if (result.value) {
        this.$liff.closeWindow();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
